import { createContext } from "react";

interface DataContextType {
  dataFromStore: Record<
    string,
    Array<
      Partial<{
        id: string;
        [key: string]: unknown;
      }>
    >
  >;
  item: Record<string, unknown>;
  getList: (
    entity: string,
    insteadName?: string,
    set?: boolean,
    withoutLoading?: boolean,
    signal?: AbortSignal
  ) => Promise<unknown>;
  getItem: (entity: string, id: string | number) => Promise<unknown>;
  createFormDataItem: (
    entity: string,
    newData: FormData | Record<string, unknown>,
    updated?: boolean,
    insteadName?: string
  ) => Promise<unknown>;
  createItem: (
    entity: string,
    newData: Record<string, unknown>,
    set?: boolean,
    withoutLoading?: boolean
  ) => Promise<unknown>;
  updateItem: (
    entity: string,
    updateItem: Record<string, unknown>,
    id: string | number,
    set?: boolean,
    insteadName?: string
  ) => Promise<void>;
  deleteItem: (
    entity: string,
    id: string | number,
    set?: boolean,
    data?: Record<string, unknown>
  ) => Promise<void>;
  deleteCategoryItem: (
    entity: string,
    id: string | number,
    set?: boolean,
    isDeletedConfirm?: boolean
  ) => Promise<unknown>;
  deleteItems: (
    entity: string,
    payload: Record<string, unknown>
  ) => Promise<void>;
  uploadXlsId: (
    entity: string,
    payload: Record<string, unknown>
  ) => Promise<void>;
  updateFormDataItem: (
    entity: string,
    updateItem: Record<string, unknown>,
    id: string | number,
    updated?: boolean,
    insteadName?: string,
    withoutLoading?: boolean
  ) => Promise<void>;
  updateAllItem: (
    entity: string,
    updateItem: Record<string, unknown>,
    set?: boolean,
    insteadName?: string
  ) => Promise<void>;
}

export const DataContext = createContext<DataContextType | null>(null);
